import type { IconProps } from "./thumba-coin";

export const CheckIcon = (props: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 11L11 17.5L20.5 5.5" stroke="currentColor" strokeWidth="4" />
  </svg>
);
